import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {DropDownListModule} from "@syncfusion/ej2-angular-dropdowns";
import {FormGroup, ReactiveFormsModule} from "@angular/forms";
import {ChangeArgs, RadioButtonModule} from "@syncfusion/ej2-angular-buttons";

@Component({
    selector: 'app-form-radio',
    imports: [
        DropDownListModule,
        ReactiveFormsModule,
        RadioButtonModule
    ],
    templateUrl: './form-radio.component.html',
    styleUrl: './form-radio.component.scss'
})
export class FormRadioComponent implements OnInit, OnChanges {

  @Input() public fCN: string = '';
  @Input() public value: string | number | boolean = '';
  @Input() public disabled: boolean = false;
  @Input() public cssClass: string = '';
  @Input() public fG: FormGroup = new FormGroup({});
  @Input() public placeholder: string = ' ';

  public tmpValue: string = '';
  private valueType: 'string' | 'number' | 'boolean' = 'string';

  public ngOnInit(): void {
    this.tmpValue = this.convertToString(this.value);
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes['value'] && changes['value'].currentValue !== changes['value'].previousValue) {
      this.tmpValue = this.convertToString(this.value);
    }
  }

  public valueChanged(event: ChangeArgs): void {
    this.value = this.convertToValue(event.value ?? '');
    this.fG.controls[this.fCN].setValue(this.value);
  }

  public checked(): boolean {
    return this.convertToValue(this.tmpValue) === this.fG.controls[this.fCN].value;
  }

  private convertToString(value: string | number | boolean): string {
    if (typeof value === 'string') {
      this.valueType = 'string';
      return value;
    } else if (typeof value === 'number') {
      this.valueType = 'number';
      return value.toString();
    } else {
      this.valueType = 'boolean';
      return value ? 'true' : 'false';
    }
  }

  private convertToValue(value: string): string | number | boolean {
    if (this.valueType === 'string') {
      return value;
    } else if (this.valueType === 'number') {
      return parseFloat(value);
    } else {
      return value === 'true';
    }
  }
}
